<template>

  <rpm-number-input
    v-if="type == 'number'"
    :type="type"
    v-bind="$attrs"
  ></rpm-number-input>

  <rpm-select-input
    v-else-if="type == 'select'"
    :type="type"
    v-bind="$attrs"
  ></rpm-select-input>

  <rpm-multiselect-input
    v-else-if="type == 'multiselect'"
    :type="type"
    v-bind="$attrs"
  ></rpm-multiselect-input>

  <rpm-auto-complete-input
    v-else-if="type == 'autocomplete'"
    :type="type"
    v-bind="$attrs"
  ></rpm-auto-complete-input>

  <rpm-textarea-input
    v-else-if="type == 'textarea'"
    :type="type"
    v-bind="$attrs"
  ></rpm-textarea-input>

  <rpm-editor-input
    v-else-if="type == 'editor'"
    :type="type"
    v-bind="$attrs"
  ></rpm-editor-input>

  <rpm-switch-input
    v-else-if="type == 'switch'"
    :type="type"
    v-bind="$attrs"
  ></rpm-switch-input>

  <rpm-radio-input
    v-else-if="type == 'radio'"
    :type="type"
    v-bind="$attrs"
  ></rpm-radio-input>

  <rpm-checkbox-input
    v-else-if="type == 'checkbox'"
    :type="type"
    v-bind="$attrs"
  ></rpm-checkbox-input>

  <rpm-file-input
    v-else-if="type == 'file'"
    :type="type"
    v-bind="$attrs"
  ></rpm-file-input>

  <rpm-default-input
    v-else
    :type="type"
    v-bind="$attrs"
  ></rpm-default-input>

  <input v-if="clone" class="hidden"/>

</template>


<script>

import RpmNumberInput from "./RpmNumberInput.vue";
import RpmSelectInput from "./RpmSelectInput.vue";
import RpmMultiselectInput from "./RpmMultiselectInput.vue";
import RpmAutoCompleteInput from "./RpmAutoCompleteInput.vue";
import RpmTextareaInput from "./RpmTextareaInput.vue";
import RpmEditorInput from "./RpmEditorInput.vue";
import RpmSwitchInput from "./RpmSwitchInput.vue";
import RpmRadioInput from "./RpmRadioInput.vue";
import RpmCheckboxInput from "./RpmCheckboxInput.vue";
import RpmFileInput from "./RpmFileInput.vue";
import RpmDefaultInput from "./RpmDefaultInput.vue";

export default {
  name: "RpmInputCore",
  inheritAttrs: false,
  components: {
    RpmNumberInput,
    RpmSelectInput,
    RpmMultiselectInput,
    RpmAutoCompleteInput,
    RpmTextareaInput,
    RpmEditorInput,
    RpmSwitchInput,
    RpmRadioInput,
    RpmCheckboxInput,
    RpmFileInput,
    RpmDefaultInput
  },
  props: {
    type: {
      type: String,
      default: "text",
    },
    invert: {
      type: Boolean,
      default: false,
    },
    clone: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: [Array, String, Object],
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    validSlot(slot) {
      return !!this.$slots[slot];
    },
  },
};
</script>
